<template>
  <div>
    <p class="flex-1 text-base text-white m-auto">
      {{ notification.message }}
    </p>
    <div class="flex-none cursor-pointer" @click="remove(notification)">
      <svg-icon
        icon="heroicons/outline/x"
        class="closebtn text-white hover:text-purple-300 h-6 w-6"
      ></svg-icon>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from "vuex";
export default {
  components: {

  },
  computed: {
    ...mapState("notification", ["notifications"]),
  },
  methods: {
    ...mapActions("notification", ["remove"]),
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
    length: {
      type: Number,
      required: false,
      default: 5000,
    },
  },
  data() {
    return {
      timeout: null,
    };
  },
  mounted() {
    this.timeout = setTimeout(
      () => this.remove(this.notification),
      this.length
    );
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>

<style></style>
